/**
 * Deep merges two objects without modifying the original objects
 * @param {Object} target - The base object
 * @param {Object} source - The object whose properties will be merged into the target
 * @returns {Object} A new object with properties from both objects merged
 */
export const deepMerge = (target, source) => {
  // Create a clone of the target to avoid modifying the original
  const output = JSON.parse(JSON.stringify(target));

  // If source or target is not an object, return source
  if (!isObject(source) || !isObject(target)) {
    return source;
  }

  // Iterate through all properties in source
  Object.keys(source).forEach((key) => {
    // If property is an object, recursively merge
    if (isObject(source[key])) {
      if (!output[key]) {
        output[key] = {};
      }
      output[key] = deepMerge(output[key], source[key]);
    } else {
      // For non-object properties, simply assign
      output[key] = source[key];
    }
  });

  return output;
};

/**
 * Checks if a value is an object (and not null or an array)
 * @param {*} item - The value to check
 * @returns {boolean} Whether the value is an object
 */
const isObject = (item) => {
  return item && typeof item === "object" && !Array.isArray(item) && item !== null;
};
